import script from "./PublicLegalFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicLegalFooter.vue?vue&type=script&setup=true&lang=js"

import "./PublicLegalFooter.vue?vue&type=style&index=0&id=08fb7ad9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fb7ad9"]])

export default __exports__